import { enCA } from "../../../../date-fns/locale/en-CA.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    enCA
  }
};